// src/utils/VerifiedDirectorContext.js

import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import api from "../api/api";
import { ENDPOINTS } from "../api/endpoints";

const VerifiedDirectorContext = createContext({
  verifiedDirector: false,
  setVerifiedDirector: () => {},
});

export function VerifiedDirectorProvider({ children }) {
  const userData = JSON.parse(localStorage.getItem("loggedInUser")) || {};
  const userId = userData?.userId || userData?.data?.userId;

  const userRole = localStorage.getItem("userRole");

  const [verifiedDirector, setVerifiedDirector] = useState(
    userData?.data?.verifiedDirector === true
  );

  useEffect(() => {
    // only COMPANY or DIRECTOR should poll
    if (
      !["COMPANY", "DIRECTOR"].includes(userRole) ||
      !userId ||
      verifiedDirector
    ) {
      return;
    }

    const fetchVerifiedDirectorStatus = async () => {
      try {
        const resp = await api.get(
          ENDPOINTS.isVerifiedDirector(),
          {
            params: { userId },
          }
        );

        const isVerified = resp.data?.data === true;

        if (isVerified) {
          setVerifiedDirector(true);

          const updatedUser = {
            ...userData,
            data: {
              ...userData.data,
              verifiedDirector: true,
            },
          };

          localStorage.setItem(
            "loggedInUser",
            JSON.stringify(updatedUser)
          );
        }
      } catch (err) {
        console.error("Verification status fetch failed:", err);
      }
    };

    // first check immediately
    fetchVerifiedDirectorStatus();

    // then every 10 seconds until verified
    const interval = setInterval(fetchVerifiedDirectorStatus, 10000);

    return () => clearInterval(interval);
  }, [userId, userRole, verifiedDirector]);

  return (
    <VerifiedDirectorContext.Provider
      value={{
        verifiedDirector,
        setVerifiedDirector,
      }}
    >
      {children}
    </VerifiedDirectorContext.Provider>
  );
}

export const useVerifiedDirector = () => {
  return (
    useContext(VerifiedDirectorContext) || {
      verifiedDirector: false,
      setVerifiedDirector: () => {},
    }
  );
};